import styled from 'styled-components';
import { getBaseTheme } from '@Themes';
import { forms, buttons } from 'seal-ui-components';

export const BackendContainer = styled.div`
    overflow: auto;
`;

export const SystemPanelContainer = styled.div`
    padding: ${getBaseTheme().spaces.insetSquish.s};
    .system_panel_title {
        font-size: ${getBaseTheme().texts.sizes.s.fontSize};
        line-height: ${getBaseTheme().texts.sizes.s.lineHeight};
    }
`;

export const Container = styled.div`
    flex-grow: 1;
    ${forms.StackedFieldLabel}, ${buttons.Button} {
        text-transform: none;
    }
`;
